export default {"src":"/_next/static/media/Whatsapp--Streamline-Ios-14.3878e1c7.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};